export const subtitles = {
    "1": {
        "startTime": 0.59,
        "endTime": 7.71,
        "transcript": "Wani uitalriit qantaugut imkut neqnun atutukait.",
        "translation": "The ones here are the bowls they use for fish."
    },
    "2": {
        "startTime": 8.37,
        "endTime": 10.6,
        "transcript": "Angtatkevkenateng.",
        "translation": "They're different sizes."
    },
    "3": {
        "startTime": 11.11,
        "endTime": 22.97,
        "transcript": "Mikelnguit cali waten mikelriitneng waten pingqerraqluteng, angenrit-llu angayuqaarit ang'uralrianeng waten pingqerraqluteng.",
        "translation": "Their children would have small ones like these, and the bigger ones, their parents would have bigger ones like these."
    },
    "4": {
        "startTime": 23.935,
        "endTime": 27.545,
        "transcript": "Neqneng piciatun imituluki.",
        "translation": "They filled them with various foods."
    },
    "5": {
        "startTime": 28.012,
        "endTime": 42.912,
        "transcript": "Uqniluteng tau͡gaten. Maa-i ayuqelriit tamakut uqnitullengnaarit makut nanvani naumatulit uqniluki.",
        "translation": "They even cooked horsetail. Now, they make cooked horstails from the plants that grow in ponds."
    },
    "6": {
        "startTime": 43.281,
        "endTime": 54.919,
        "transcript": "[?]-llu augitneng, imarpigmiutaat augitneng ilaluku tamana meq tamakut-llu piluki.",
        "translation": "And the [?] blood, they would add blood from sea animals to the water there."
    },
    "7": {
        "startTime": 55.532,
        "endTime": 61.444,
        "transcript": "Tau͡ga-i uqnaqegtaarauluteng. Assirluteng-am pinaurtut nallunritellriit.",
        "translation": "That was good cooked horsetail. Those who knew would make them well."
    },
    "8": {
        "startTime": 61.52,
        "endTime": 75.732,
        "transcript": "Maa-i tau͡ga ayuqenrilngu[?] tamakut maa-i mat'um nalliini makuneng cuupaneng, cuupaneng pitukeput wangkuta",
        "translation": "These various ways today of making soup, what we call soup"
    },
    "9": {
        "startTime": 75.945,
        "endTime": 79.045,
        "transcript": "Tau͡gaam ayuqenritait.",
        "translation": "But they're not the same."
    },
    "10": {
        "startTime": 79.239,
        "endTime": 86.339,
        "transcript": "Tepait allakauqapigtut tamakut civuliamta piliaqetullrat.",
        "translation": "The smell of what our ancestors made were completely different."
    },
    "11": {
        "startTime": 88.071,
        "endTime": 99.683,
        "transcript": "Imkuneng-llu pillerkarcuraqluteng imkuneng-llu ugnaraat makuneng neqaitneng marayallerneng",
        "translation": "And they would gather them, including the food voles gathered in the ground"
    },
    "12": {
        "startTime": 100.046,
        "endTime": 107.734,
        "transcript": "Imkuneng-llu utngungssaarneng pitukiitneng, iitarneng-llu cali pitukiitneng.",
        "translation": "Including what they call mare's-tail tubers, and what they call tall cottongrass."
    },
    "13": {
        "startTime": 107.859,
        "endTime": 113.197,
        "transcript": "Tamatumun tang cuupiameggnun tamakut avuurarkauluki.",
        "translation": "They would add those to their soups."
    },
    "14": {
        "startTime": 114.422,
        "endTime": 116.197,
        "transcript": "Cali im' waten...",
        "translation": "And like this..."
    },
    "15": {
        "startTime": 116.228,
        "endTime": 129.791,
        "transcript": "Makut maa-i kegginaqut waten ayuqelriit ayuqenrilnguut makut wani taqevkaraqait imkuneng angalkuneng pitukaita.",
        "translation": "These various masks like this are asked to be made by those whom they call shamans."
    },
    "16": {
        "startTime": 130.078,
        "endTime": 133.541,
        "transcript": "Taqevkaraqait ayuqevkenaki.",
        "translation": "They ask for various masks to be made."
    },
    "17": {
        "startTime": 134.016,
        "endTime": 148.091,
        "transcript": "Waten-llu iingita cali ingluit cali inglupianeng iingqercelluki taqevkaraqait ayuqenrilenguut makut, angalkuita tau͡gaam.",
        "translation": "They, only the shamans, asked for these various masks to made with only a single eye on each."
    },
    "18": {
        "startTime": 148.235,
        "endTime": 151.872,
        "transcript": "Waten-ll' taqsuunaki Cupiit makut.",
        "translation": "And these Cupiit would not be done with them like this."
    },
    "19": {
        "startTime": 152.085,
        "endTime": 158.122,
        "transcript": "Uumeng-am yuraryarameng aturaqamta makut tau͡ga atuugarkauluteng.",
        "translation": "These would be used when we practiced traditional dancing."
    },
    "20": {
        "startTime": 158.672,
        "endTime": 163.297,
        "transcript": "Aturluki piarkauluki, kegginaquneng-llu acirluki.",
        "translation": "They would have to use them, and called them masks."
    },
    "21": {
        "startTime": 163.303,
        "endTime": 165.816,
        "transcript": "PIkna-qaa quleqlia caullraneng nalluan?",
        "translation": "Do you what the one above was?"
    },
    "22": {
        "startTime": 165.953,
        "endTime": 168.716,
        "transcript": "Una wani nalluaqa caullra.",
        "translation": "I don't know what this was."
    },
    "23": {
        "startTime": 169.528,
        "endTime": 172.578,
        "transcript": "Makuneng-ll' ayuqenrilngurnek waten.",
        "translation": "And these were different."
    },
    "24": {
        "startTime": 173.072,
        "endTime": 182.297,
        "transcript": "Makut tau͡gaam ayuqenritut ukut. Makut maani uitalriit caullra wii uum nallruaqa.",
        "translation": "But these are different. I don't know what these here are."
    },
    "25": {
        "startTime": 182.453,
        "endTime": 184.091,
        "transcript": "Tua-i-mi aciqlia?",
        "translation": "What about the bottom?"
    },
    "26": {
        "startTime": 185.841,
        "endTime": 194.129,
        "transcript": "Una tau͡ga wanigga tangvallemni waten makut",
        "translation": "From what I saw about these here"
    },
    "27": {
        "startTime": 195.642,
        "endTime": 205.654,
        "transcript": "Naugga cat tamalkurmeng wangkuta caunrilnge'rmeng piunrilnge'rmeng-llu atengqerraqelriit.",
        "translation": "You know, we have names for everything, even if they seem insignificant or unimportant."
    },
    "28": {
        "startTime": 206.117,
        "endTime": 217.205,
        "transcript": "Una atengqerrluni, iliit atengqerrluni neqem cuaneng, iliini unguvalriim cuaneng atengqerraqluni.",
        "translation": "This had a name, one of them had the name of the spirit of a fish, sometimes had the name of the spirit of a living being."
    },
    "29": {
        "startTime": 217.386,
        "endTime": 227.286,
        "transcript": "Makut una angalkuita calinguaqluki tamakut alerquutekluki kegginaqum nalliini atu'urkateng pilaqait.",
        "translation": "Their shamans would instruct them to add those for their rituals when they were going to use them in mask ceremonies."
    },
    "30": {
        "startTime": 227.293,
        "endTime": 234.23,
        "transcript": "Qanrutkarkauluki-am cali ellaita ankata au͡ga-i yuraqataqata.",
        "translation": "They would also speak about them when they were going to go out to dance."
    },
    "31": {
        "startTime": 234.718,
        "endTime": 236.505,
        "transcript": "Tamakut-qaa angalkut?",
        "translation": "Those shamans?"
    },
    "32": {
        "startTime": 236.518,
        "endTime": 240.23,
        "transcript": "Angalkut tamakut, Cupiit-ll' piyuunaku.",
        "translation": "Those shamans, and the Cupiit wouldn't."
    },
    "33": {
        "startTime": 240.368,
        "endTime": 250.218,
        "transcript": "Waten tau͡gaam makut maa-i pikenrilengraaki uum tangnircaucirluki makuneng pituaqait.",
        "translation": "But even though these are not their helping spirits, they would put these as decoration."
    },
    "34": {
        "startTime": 250.237,
        "endTime": 257.275,
        "transcript": "Waten-llu aarrangiiraat makut piit waten-llu tangnircaucirrlainarluki.",
        "translation": "They would also always decorate these parts of the long-tailed ducks like this."
    },
    "35": {
        "startTime": 263.387,
        "endTime": 280.287,
        "transcript": "Una tau͡ga-i-ll' wanigg' tangvagaqa nunam mat'um unguvalriarin wani una ilakaat una maani nunami pitulit.",
        "translation": "And the living being on land that I'm looking at here is one of the animals of the land."
    },
    "36": {
        "startTime": 280.531,
        "endTime": 284.419,
        "transcript": "Pagkuneng-am tau͡gaam tangnerrartua.",
        "translation": "But I've never seen the ones up there before."
    },
    "37": {
        "startTime": 284.544,
        "endTime": 293.419,
        "transcript": "PIkavet tau͡gaam tat'mi qaingakun ciuteruagneng pingqerrarkauguq.",
        "translation": "But up there on it's forehead, it needs to have ears."
    },
    "38": {
        "startTime": 293.425,
        "endTime": 300.938,
        "transcript": "Makut unguvalriit ciutengqerraqelriit alaunaki ayuqevkenateng.",
        "translation": "These living things have different ears that are visible."
    },
    "39": {
        "startTime": 301.413,
        "endTime": 306.488,
        "transcript": "Makut wani tau͡ga [?] alairtetukait maa-i makut.",
        "translation": "[?] bring these up."
    },
    "40": {
        "startTime": 307.582,
        "endTime": 312.769,
        "transcript": "Pagkuneng-am pingqelriameng tangyuitua maani nunam iluani.",
        "translation": "I don't see anyone with those up there in these villages."
    },
    "41": {
        "startTime": 313.007,
        "endTime": 325.269,
        "transcript": "Makuneng tangerrsaqlilrianga makuneng, tau͡gaam tangnircuucirluki ellaita piliaqestaita camirastaita pituit.",
        "translation": "I've never seen these before, but the ones who make them decorate them."
    },
    "42": {
        "startTime": 326.232,
        "endTime": 329.145,
        "transcript": "Aturaqamegteggu tau͡ga-i qaillun piaqluku?",
        "translation": "What would they do when they used it?"
    },
    "43": {
        "startTime": 329.395,
        "endTime": 338.007,
        "transcript": "Tau͡ga-i atuqataraqamegteggu waten-llu caullra uum nalqigutekaqluku, cauniluku tau͡ga una.",
        "translation": "When they were going to use it, they would explain what it is, saying what it is."
    },
    "44": {
        "startTime": 338.295,
        "endTime": 345.37,
        "transcript": "Maa-i-ll' makut cat cuitneng acirluki. Cuit-gguq.",
        "translation": "They also called these the spirits of thigns. They called them spirits."
    },
    "45": {
        "startTime": 348.075,
        "endTime": 363.962,
        "transcript": "Una-ll' wanigga, una wanigga makunun unguvalrianun imarpigmiutarnun cukniluku pingataqaat una.",
        "translation": "And these here, I think they say that this is the spirit of some living thing, a marine animal."
    },
    "46": {
        "startTime": 364.437,
        "endTime": 368.575,
        "transcript": "Man'a-llu au͡gatiini waten ayuqelria",
        "translation": "The one around it like this"
    },
    "47": {
        "startTime": 369.075,
        "endTime": 385.713,
        "transcript": "Naugga imumeng pug'aqameng pugumaaqelriit iliini engelkurluki, iliini una engelkurluku, iliini-ll' man'a engelkurluku, waten-llu qanengqerrsuumaluteng.",
        "translation": "You know when they surface, the ones that surface are sometimes up to here, sometimes up to here, sometimes up to here, and can have their mouths here."
    },
    "48": {
        "startTime": 386.301,
        "endTime": 395.888,
        "transcript": "Imkumeng tau͡gaam perelriameng qanengqerrarkauyaaquq una, qanengqerrarkaulriaruyaaquq.",
        "translation": "However, this is supposed to have a crooked mouth here."
    },
    "49": {
        "startTime": 396.776,
        "endTime": 402.213,
        "transcript": "Tamakuneng keggunengqerrarkaulriaruyaaqluni tau͡ga waten tau͡ga-i.",
        "translation": "It's supposed to have teeth like this."
    },
    "50": {
        "startTime": 402.626,
        "endTime": 416.026,
        "transcript": "Ukuk cali akiqliqlutek waten uitauralriik uum kaikuni neryuumaarkauluki uum ungungssiaraam.",
        "translation": "And these across from each other, this animal would eat them when it's hungry."
    },
    "51": {
        "startTime": 420.345,
        "endTime": 426.695,
        "transcript": "Wii tau͡gaten ayuqelriameng unatneng tangyuitua.",
        "translation": "I don't see hands like that."
    },
    "52": {
        "startTime": 426.702,
        "endTime": 434.327,
        "transcript": "Cat tamalkurmeng unatengqertut tallimalngurteksaunaki waten ayuqerkaulrianeng.",
        "translation": "Everything has hands that don't go up to five that are like this."
    },
    "53": {
        "startTime": 435.933,
        "endTime": 445.258,
        "transcript": "Tau͡gaam una wanigg' piliaqestiitun waten pillrullinia.",
        "translation": "But the maker made it in their way like this."
    },
    "54": {
        "startTime": 450.764,
        "endTime": 454.402,
        "transcript": "Tau͡ga-i iillanangnaqluku.",
        "translation": "We look at it with awe."
    },
    "55": {
        "startTime": 454.565,
        "endTime": 464.99,
        "transcript": "Angalku[milu]nun tau͡ga taqellruata wangkuta Cup'igni tangvagciigatarput angalku[milu]nun taqellrullinian.",
        "translation": "Since they're made for shamans, we Cupiit cannot watch them because they're made for shamans."
    },
    "56": {
        "startTime": 468.121,
        "endTime": 472.146,
        "transcript": "Qaillun un' kangingengnaqengramteggu kangingengaitaqa wii.",
        "translation": "Even we try to understand this, I will not understand it."
    },
    "57": {
        "startTime": 476.415,
        "endTime": 483.802,
        "transcript": "Qanrutketulqait una wanigga uungunilukui piaqluku.",
        "translation": "They would say that this was a certain thing."
    },
    "58": {
        "startTime": 484.852,
        "endTime": 494.065,
        "transcript": "Waten-llu pirrlainarluku waten wanigg' ukut unaitait wanigg' uitaut. Unatai, unatai uitaut.",
        "translation": "And they would always do it like this with their hands here. It's hands are here."
    },
    "59": {
        "startTime": 494.077,
        "endTime": 504.49,
        "transcript": "Ukuk-llu cakuni kaikuni wanigg' unatet nuniitni tegulukek unatmineng aturluni elliin uum neryuumiluku.",
        "translation": "And if it's hungry, it will take these things around the hands and it can eat it with its hands."
    },
    "60": {
        "startTime": 505.377,
        "endTime": 507.065,
        "transcript": "Tau͡ga-q' kangingarci?",
        "translation": "Do you understand it?"
    },
    "61": {
        "startTime": 507.078,
        "endTime": 508.315,
        "transcript": "Ii-i.",
        "translation": "Yes."
    },
    "62": {
        "startTime": 520.178,
        "endTime": 527.19,
        "transcript": "Ak'a tau͡gaam niitetullruunga wii. Waten taqumalriameng uumeng tangvakallrunritua.",
        "translation": "I used to only hear of them long ago. I've never seen one finished like this."
    },
    "63": {
        "startTime": 527.591,
        "endTime": 543.078,
        "transcript": "Ellaita tamakut cuut ilaita malrurtetulliniaki waten qan[rit]",
        "translation": "Because some people would make two mouths like this"
    },
    "64": {
        "startTime": 544.916,
        "endTime": 552.016,
        "transcript": "Wanigg' una tamluani uitalria malruurrlukek.",
        "translation": "They would make two of them on the chin here."
    },
    "65": {
        "startTime": 552.716,
        "endTime": 562.778,
        "transcript": "Tau͡ga-i-ll' camun, camun imumun allayuk'ngaameggnun alingnaqsuksuknguaqunegteggu-llu",
        "translation": "And then if they found something very strange and if they thought it was something scary"
    },
    "66": {
        "startTime": 563.391,
        "endTime": 574.129,
        "transcript": "Piluteng tau͡gaggun qulliakun anlluki, tau͡gamtell' atliakun kanaggun anlluki, cukariinarluteng anteqtaarturluku.",
        "translation": "They would depict them being removed from the top, then being removed from the bottom, removing them with increasing speed."
    },
    "67": {
        "startTime": 574.579,
        "endTime": 583.792,
        "transcript": "Tamakut cegtullerneng pituluki atliit. Cegtullret-gguq.",
        "translation": "They called the ones on the bottom cegtullret. They called them cegtullret."
    },
    "68": {
        "startTime": 584.867,
        "endTime": 587.092,
        "transcript": "Tau͡ga-qaa? (Ii-i).",
        "translation": "Is that all? (Yes.)"
    },
    "69": {
        "startTime": 587.748,
        "endTime": 593.136,
        "transcript": "[?]qelrianeng imkuneng tangerpakanritua.",
        "translation": "I don't see too much of those that [?]."
    },
    "70": {
        "startTime": 597.386,
        "endTime": 600.599,
        "transcript": "Tau͡gaam tau͡ga ayuqenrilmiut.",
        "translation": "But they're also different."
    },
    "71": {
        "startTime": 600.961,
        "endTime": 608.799,
        "transcript": "Kanani tangyuilkengaput-llu wangkuta unguvalriari imarpiim ayuqenritellruut ak'a.",
        "translation": "There were also different kinds of marine animals that we didn't see long ago."
    },
    "72": {
        "startTime": 608.812,
        "endTime": 619.774,
        "transcript": "Maa-i tau͡gken tangerrnauqerciigaliluteng, nallunariqapiggluteng, nallunarimaluteng, ilait [nangtu?rluteng].",
        "translation": "Now, however, we don't commonly see them anymore, becoming very rare, becoming rare, and some [?have low populations]."
    },
    "73": {
        "startTime": 620.787,
        "endTime": 629.062,
        "transcript": "Una wanigg' angenqerruaruyugnarquq una waten pimalria.",
        "translation": "This part that goes like this seems to be a large ice floe."
    },
    "74": {
        "startTime": 629.543,
        "endTime": 636.893,
        "transcript": "Uum wanigga angenqerruaq una atu'urkaqaa.",
        "translation": "It will go on the large ice floe."
    },
    "75": {
        "startTime": 639.012,
        "endTime": 642.562,
        "transcript": "Una tau͡gaam caullra kangingumanritaqa.",
        "translation": "But I don't understand what this is."
    },
    "76": {
        "startTime": 645.369,
        "endTime": 649.231,
        "transcript": "Cauga? Ca[?]uga?",
        "translation": "What is it? What is it?"
    },
    "77": {
        "startTime": 650.107,
        "endTime": 652.707,
        "transcript": "Angenqurraa wani cauga?",
        "translation": "What's the angenqaq?"
    },
    "78": {
        "startTime": 653.676,
        "endTime": 656.064,
        "transcript": "Cameng, cameng una, cauga?",
        "translation": "What is it?"
    },
    "79": {
        "startTime": 656.077,
        "endTime": 657.127,
        "transcript": "Angenqaq.",
        "translation": "Angenqaq."
    },
    "80": {
        "startTime": 657.139,
        "endTime": 658.726,
        "transcript": "Angenqaq cauga?",
        "translation": "What's an angenqaq?"
    },
    "81": {
        "startTime": 658.739,
        "endTime": 669.426,
        "transcript": "Naugga imarpigmi imkut cikut can'ulriit unaken tag'tulriit iliini mamtuluteng. Tamaa-i-gguq tamakut angenqat.",
        "translation": "You know, the thick ice that goes toward land from far out in the ocean, sometimes thick. Those are called angenqat."
    },
    "82": {
        "startTime": 669.539,
        "endTime": 673.539,
        "transcript": "(Tagenqat.) Angenqat. (Angenqat.) Angenqat.",
        "translation": "(Tagenqat.) Angenqat. (Angenqat.) Angenqat."
    },
    "83": {
        "startTime": 674.821,
        "endTime": 687.608,
        "transcript": "Imna tau͡gken maaken neqegvaneng tailuni nav'karyukaareluni ilii cekullallerneng, cekullaq.",
        "translation": "However, the one that comes from the north that breaks easily, some of them are cekullallret, cekullaq."
    },
    "84": {
        "startTime": 689.583,
        "endTime": 697.358,
        "transcript": "Ukuk wanigga nalqikapigglukek pingnaq'nge'rma uunguciitaqa, waten cali iigluni.",
        "translation": "But even if I try to explain these, I have no idea about it, even the eyes like this."
    },
    "85": {
        "startTime": 699.289,
        "endTime": 706.227,
        "transcript": "Una tau͡gaam, una wanigg' una nunami uitalriaruyukluku wii umyugartequa tau͡ga-i.",
        "translation": "But this, I think that this is something on land here."
    },
    "86": {
        "startTime": 706.252,
        "endTime": 714.327,
        "transcript": "Una wanigga qanra uivenqeggluni wani kegginam iluani.",
        "translation": "Its mouth here is round in the face."
    },
    "87": {
        "startTime": 717.483,
        "endTime": 732.408,
        "transcript": "Una wanigg' pituyugnarqaat uksuarmi, up'nerkami-llu merneng pingqerrlainarluki, nunaqlilirrnainarluki",
        "translation": "I think they would always put water beside us in the fall and spring"
    },
    "88": {
        "startTime": 733.164,
        "endTime": 736.677,
        "transcript": "Qavaasqekaitkut ak'a, wii-ll' pitullrulrianga.",
        "translation": "They would tell us sleep like that long ago, and I used to as well."
    },
    "89": {
        "startTime": 736.689,
        "endTime": 746.677,
        "transcript": "Imkut qavaasqellua uksuarmi mermeng nunaklirilua caskaq imiqangraan elliqerluku.",
        "translation": "They would tell me to sleep in the fall with water beside me, even just filling a cup and placing it by me."
    },
    "90": {
        "startTime": 747.115,
        "endTime": 752.815,
        "transcript": "Tau͡gamtellu ca imna caanika-llu elliqerlua pisqeńauraa.",
        "translation": "Then he would tell me to put something, even a kettle."
    },
    "91": {
        "startTime": 752.959,
        "endTime": 766.259,
        "transcript": "Una wanigg' qaneni-gguq aturluku cuum wavet qavaqan wavet pull'uni uumun tau͡ga aturluni una wanigga ner'aqaa taum.",
        "translation": "They say that this creature uses its mouth, bends down to a sleeping person, and eats him with that."
    },
    "92": {
        "startTime": 769.653,
        "endTime": 775.053,
        "transcript": "Melugarciqaa. Melugarluku.",
        "translation": "It will suck him dry. It will suck him dry."
    },
    "93": {
        "startTime": 775.866,
        "endTime": 790.128,
        "transcript": "Tau͡ga-llu tauna melugaq'ngaa waten uumun pirraarcelluni waten anerteqesciigatliniaquq, cuusciiganani.",
        "translation": "And then the one that was sucked dry by this cannot breathe like this, cannot live."
    },
    "94": {
        "startTime": 790.154,
        "endTime": 792.716,
        "transcript": "Wagg'uq mer'irluku.",
        "translation": "That's getting sucked dry by Meriiq."
    },
    "95": {
        "startTime": 793.217,
        "endTime": 796.454,
        "transcript": "Mel'irturluku tau͡ga alerquutengqerrluni.",
        "translation": "One is instructed to always have water nearby."
    },
    "96": {
        "startTime": 796.629,
        "endTime": 808.529,
        "transcript": "Waten-llu qec'gaqameng elpengaqaciteng tamakut qec'gaqameng mermun merpalla'arcuunateng, [?]luteng tau͡gaam pituluteng.",
        "translation": "And when they notice them jumping, when they jump into the water, they don't splash, but they [?]."
    },
    "97": {
        "startTime": 810.436,
        "endTime": 811.916,
        "transcript": "Tau͡ga-i-qaa? (Ii-i.)",
        "translation": "Is that all? (Yes.)"
    },
    "98": {
        "startTime": 811.921,
        "endTime": 815.991,
        "transcript": "...yaaqelriim pamyuituq tau͡gaam.",
        "translation": "...but it has no tail."
    },
    "99": {
        "startTime": 816.961,
        "endTime": 823.511,
        "transcript": "Neqnguyaaquq una tau͡gaam pamyuunani, imkuneng-llu piinani.",
        "translation": "This is actually a fish but it has no tail, and doesn't have those things."
    },
    "100": {
        "startTime": 824.691,
        "endTime": 834.361,
        "transcript": "Una cali wanigga qaqimanganani una pamyungqerrluni. Pamyua pika-i.",
        "translation": "This one too seems to be complete with a tail. Its tail is up there."
    },
    "101": {
        "startTime": 836.701,
        "endTime": 842.111,
        "transcript": "Waten-ll' [?] pingqerrarkauvkenani piyaaquq.",
        "translation": "This isn't supposed to have [?] like this as well."
    },
    "102": {
        "startTime": 842.481,
        "endTime": 846.431,
        "transcript": "Neqnguluni [?].",
        "translation": "It's a fish [?]."
    },
    "103": {
        "startTime": 846.631,
        "endTime": 852.991,
        "transcript": "Ayuqenrilmiameng kankut imarpiim neqai kuimatulit waten.",
        "translation": "It's also because the fish that swim down in the ocean like this are different."
    },
    "104": {
        "startTime": 854.606,
        "endTime": 865.346,
        "transcript": "Tau͡gaggun-llu ukut wanigga taringellemkun una-ll' uunguciiqaarluku qanraneng elitaqucirlua piaqa.",
        "translation": "And through my understanding with that, after having no idea what it was, I recognize it with this one's mouth."
    },
    "105": {
        "startTime": 866.041,
        "endTime": 871.251,
        "transcript": "Au͡ga-i mer'irluki pitukait.",
        "translation": "Long ago, they would suck out the water from them at night."
    },
    "106": {
        "startTime": 871.321,
        "endTime": 877.701,
        "transcript": "Tamakut-qaa angalkut aturluki, aturaqamegteki piaqluki? (Ii-i.)",
        "translation": "Would the shamans use those? (Yes.)"
    },
    "107": {
        "startTime": 879.476,
        "endTime": 886.786,
        "transcript": "Tau͡gaam neqnguar waten aturaqamegteggu pamyuicuitaat angalkuungameng tamakut.",
        "translation": "But when they used this fish mask, it would never be without a tail because they are shamans."
    },
    "108": {
        "startTime": 896.616,
        "endTime": 899.906,
        "transcript": "Uumeng tau͡ga nalluunga. Nalluunga.",
        "translation": "I don't know about this. I don't know."
    },
    "109": {
        "startTime": 900.24,
        "endTime": 908.57,
        "transcript": "Una wani qaill' uunguciitaqa. Qanrutkesciigataqa una tat'mikun pingqelria.",
        "translation": "I have no idea about htis. I can't talk about the one with this on its forehead."
    },
    "110": {
        "startTime": 908.66,
        "endTime": 918.78,
        "transcript": "Au͡gkut Kuigpagmiut [?] qanaatellemkek maani Kuigpiim angalkut ilaitnin pikellruniluku pilqaak.",
        "translation": "The people on the Yukon, when I spoke to them, thye said that it belonged to one of the Yukon shamans."
    },
    "111": {
        "startTime": 918.995,
        "endTime": 923.195,
        "transcript": "Tau͡ga tua pituit pikestengqetuluki.",
        "translation": "They say they have owners."
    },
    "112": {
        "startTime": 925.07,
        "endTime": 935.81,
        "transcript": "Tau͡gaam nunamni wii camani angalkut tamakut atauciullrunrilameng-llu",
        "translation": "But in my village down there, because there weren't just single shamans"
    },
    "113": {
        "startTime": 936.395,
        "endTime": 948.975,
        "transcript": "Waten ca man'a alairtaqamegteggu nalqigutekluku-gg' tua-i una wanigga taumun cuqliluku, cuqliluku-llu.",
        "translation": "When they reveal or explain things, they would use metaphors, they would use metaphors."
    },
    "114": {
        "startTime": 950.96,
        "endTime": 959.38,
        "transcript": "Makuneng pingqeyuicaaqut imkut tangtullrenka makuneng qatelrianeng waten.",
        "translation": "The ones I see wouldn't have these white things."
    },
    "115": {
        "startTime": 959.485,
        "endTime": 970.005,
        "transcript": "Tau͡gaam ellaita makut piliaqestait pilivkaraqateng tangnircautekluki pituit makut caarrangiameng taqluki.",
        "translation": "But when they makers had them made, they would decorate them with little creatures."
    },
    "116": {
        "startTime": 970.9,
        "endTime": 975.93,
        "transcript": "Pingqelriameng caitqapik tayim' niitellrunritua.",
        "translation": "I've never once heard of any with one."
    },
    "117": {
        "startTime": 977.3,
        "endTime": 984.83,
        "transcript": "Ingkumi au͡gatiini uitalriik tamakuk malrugneng tauna iingqerciqnganani.",
        "translation": "The ones around it, it seems that it would have two eyes."
    },
    "118": {
        "startTime": 985.39,
        "endTime": 992.37,
        "transcript": "Maybe I should get Peter to hold the mic. Would that be better? Peter, would you hold this one too? I think it might work better.",
        "translation": "Maybe I should get Peter to hold the mic. Would that be better? Peter, would you hold this one too? I think it might work better."
    },
    "119": {
        "startTime": 992.375,
        "endTime": 998.355,
        "transcript": "Waten cat cetamaneng iingqelrianeng tangellrunritua.",
        "translation": "I've never seen anything with four eyes like this."
    },
    "120": {
        "startTime": 999.02,
        "endTime": 1002.78,
        "transcript": "Qununiuyalriamun allakarauguq.",
        "translation": "It's a little different from what would be a half-seal mermaid."
    },
    "121": {
        "startTime": 1003.185,
        "endTime": 1012.715,
        "transcript": "Ataucirrarmeng iingqerquni, man'a-llu ipkuni, ipegluni waten, ipegtaluni pikan",
        "translation": "If this had one single eye, and this was sharp, sharp like this, if it were this sharp"
    },
    "122": {
        "startTime": 1013.065,
        "endTime": 1022.165,
        "transcript": "Taum-llu ipelriim aciakun qanekcuar, qanekcuartangqerrarkauyaaquq.",
        "translation": "And a mouth under that sharp part, it's supposed to have a small mouth."
    },
    "123": {
        "startTime": 1022.49,
        "endTime": 1028.56,
        "transcript": "Una wani tamakunun enqakutekluku taqestiin taqellrungataa.",
        "translation": "The maker seemed to make those to remember those."
    },
    "124": {
        "startTime": 1028.68,
        "endTime": 1032.1,
        "transcript": "Ca, muragaugut-qaa unkut qukaani?",
        "translation": "What, is that wood down in the middle?"
    },
    "125": {
        "startTime": 1032.635,
        "endTime": 1034.025,
        "transcript": "Qang'a.",
        "translation": "No."
    },
    "126": {
        "startTime": 1036.305,
        "endTime": 1047.305,
        "transcript": "Makut maa-i qununit imkut qaralingqerraqut waten qalirtutuluteng.",
        "translation": "These half-seal mermaids have decorations like this depicted seal gut rain parkas."
    },
    "127": {
        "startTime": 1048.06,
        "endTime": 1059.26,
        "transcript": "Una wani wangkuta pingqellruyaaqukut camani tamaku[uluni] qalirtuluni, qalirluni waten [?]luni.",
        "translation": "We had one of those down at home with a seal gut rain parka, a seal gut rain parka [fastened] like this."
    },
    "128": {
        "startTime": 1061.745,
        "endTime": 1067.405,
        "transcript": "Una-m' tua-i wanigg cali tua uunguciitaqa.",
        "translation": "I have no idea what this is either."
    },
    "129": {
        "startTime": 1068.01,
        "endTime": 1077.79,
        "transcript": "Una wanigg' talliruaruyaaquk ukuk, una wanigg' teguqatarluku.",
        "translation": "This one has what are supposed to be arms about to take this."
    },
    "130": {
        "startTime": 1081.745,
        "endTime": 1087.285,
        "transcript": "Waten pug'tuliugut makut. Pug'tuliugut makut maa-i.",
        "translation": "These here surface in the ocean. These surface in the ocean."
    },
    "131": {
        "startTime": 1087.54,
        "endTime": 1092.45,
        "transcript": "Pikegkut-gga tukulleguarit ukut.",
        "translation": "And up there are their back flippers, these ones."
    },
    "132": {
        "startTime": 1093.57,
        "endTime": 1098.77,
        "transcript": "Ukut-gga imkut unatkegguarit.",
        "translation": "And these are their foreflippers."
    },
    "133": {
        "startTime": 1101.67,
        "endTime": 1108.01,
        "transcript": "Maa-i man' au͡gatiini uitalria mer'unguarcelluku umyugaqluku pitungataat.",
        "translation": "I think the one around it depicts water."
    },
    "134": {
        "startTime": 1111.675,
        "endTime": 1118.725,
        "transcript": "Tamakut nallunritarallrenka tau͡gani qaneryaaqekemni imairutua.",
        "translation": "I have nothing more to say about what I know."
    }
};